import {
  AhaEditorUtils,
  Tool,
  isEmbeddedReportElement,
  slate,
} from '@aha-app/aha-editor-v2';
import { configureReport } from '../components/ConfigureReportModal';
import { bookmarkURL } from 'components/Dashboards/helpers';
import { Panel } from 'components/Dashboards/store/records';
import gearIcon from 'images/icons/gear.svg?inline';

class ToolConfigureReport extends Tool {
  static toolName = 'Configure view';
  static iconSvg = gearIcon;

  static action({ editor }): void {
    const reports = slate.Editor.above(editor, {
      match: isEmbeddedReportElement,
    });
    if (!reports) return;

    const path = slate.pathRef(editor, reports[1]);

    configureReport(reports[0].payload)
      .then(payload => {
        if (payload && path.current) {
          slate.Transforms.setNodes(
            editor,
            { payload, bookmark_path: bookmarkURL(new Panel(payload)) },
            { at: path.current, match: isEmbeddedReportElement }
          );
        }

        path.unref();
      })
      .catch(err => {
        console.error(err);
        path.unref();
      })
      .finally(() => {
        AhaEditorUtils.Editor.blur(editor);
      });
  }
}

export default ToolConfigureReport;
